import { deserialize } from './serialize';

const InlineHtml = {
  deserialize,
};

export default InlineHtml;
